import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";

import _ from "lodash";
import controller from "./duck";
import controllerLocal from "../locales/duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import { Modal } from "react-bootstrap";
import { getFormattedDateForPicker, getFormattedDate } from "../utils/utils";

const { Text } = Inputs;

function ReservasGeneralList({ history, match }) {
  const dispatch = useDispatch();
  const todayDMY = getFormattedDate();


  const [servicioFiltro, setServicioFiltro] = useState(null);

  const modelReservasByLocal = useSelector(
    (state) => state.reservasConfirmadasByLocal
  );
  const modelCancelar = useSelector((state) => state.cancelarReserva);
  const modelComentarioInterno = useSelector((state) => state.addComentarioInterno);
  const modelNroMesa = useSelector((state) => state.addNroMesa);
  const modelLocal = useSelector((state) => state.localById);

  const [reservas, setReservas] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [fechaInicio, setFechaInicio] = useState(todayDMY);
  const [fechaFin, setFechaFin] = useState(todayDMY);
  const [local, setLocal] = useState(null);
  const [serviciosPadreOptions, setServiciosPadreOptions] = useState([]);
  const [serviciosOptions, setServiciosOptions] = useState([]);
  const [servicio, setServicio] = useState(null);
  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [profesional, setProfesional] = useState(null);
  const [servicioPadre, setServicioPadre] = useState(null);
  const [currentSubcategoria, setCurrentSubcategoria] = useState(null);
  const [currentServicio, setCurrentServicio] = useState(null);
  const [currentProfesional, setCurrentProfesional] = useState(null);
  const [ambienteOptions, setAmbienteOptions] = useState([]);
  const [ambiente, setAmbiente] = useState(null);
  const [show, setShow] = useState(false);
  const [showModalNroMesa, setShowModalNroMesa] = useState(false);
  const [comentarioInterno, setComentarioInterno] = useState("");
  const [nroMesa, setNroMesa] = useState(0);
  const [idComentarioInterno, setIdComentarioInterno] = useState(null);

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
    if (data && data.data) {
      if (data.data.ambientes && data.data.ambientes.length > 0) {

        const ambientes = data.data.ambientes.map((row) => {
          const opcion = {
            label: row.nombre,
            value: row.nombre,
          };
          return opcion;
        });
        setAmbienteOptions(ambientes);
      }

      setLocal(data.data);

      const subcategoriaOptions = data.data.subCategorias.map((row) => {
        if (row.estado === "ACTIVO") {
          return {
            label: row.nombre,
            value: row.id,
          };
        }
      });
      setServiciosPadreOptions(subcategoriaOptions);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
  }, [modelLocal]);

  useEffect(() => {
    if (servicioPadre) {
      const hijos = local.servicios.filter(
        (elem) => elem.subCategoriaId === servicioPadre
      );
      const servicioOpciones = hijos.map((row) => {
        if (row.estado === "ACTIVO") {
          return {
            label: row.nombre,
            value: row.id,
            ...row,
          };
        }
      });
      setServiciosOptions(servicioOpciones);
      setServicio(null);
      setProfesional(null);
    }
  }, [servicioPadre]);

  useEffect(() => {
    if (servicio) {
      if (local && local.categoriaId !== "60f806a5e3e9af972fe85c7a") {
        const servicioSelected = serviciosOptions.filter(
          (elem) => elem.id === servicio
        );
        const idProfesionales = servicioSelected[0].profesionales;
        const arrayprofesionales = [];
        idProfesionales.forEach((row) => {
          const reg = local.profesionales[row];
          if (reg && reg.estado === "ACTIVO") {
            reg.value = reg.id;
            reg.label = reg.nombre;
            arrayprofesionales.push(reg);
          }
        });
        setProfesionalesOptions(arrayprofesionales);
        setProfesional(null);
      }
    }
  }, [servicio]);

  useEffect(() => {
    if (profesional) {
    }
  }, [profesional]);

  useEffect(() => {
    const data = modelCancelar?.data?.data;
    const error = modelCancelar?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.cancelarReservaDuck.actions.clear());
    }
    if (data) {
      setReservas([]);
      dispatch(
        controller.getReservasByLocalThunk(
          null,
          match.params.id,
          moment(fechaInicio).format("YYYY-MM-DD"),
          moment(fechaFin).format("YYYY-MM-DD"),
          activePage,
          pageSize,
          profesional,
          servicio,
          ambiente
        )
      );
      dispatch(controller.cancelarReservaDuck.actions.clear());
    }
  }, [modelCancelar]);

  useEffect(() => {
    const data = modelReservasByLocal?.data?.data;
    const error = modelReservasByLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.getReservasObsoletasDuck.actions.clear());
    }
    if (data) {
      setReservas(data.data);


      dispatch(controller.getReservasObsoletasDuck.actions.clear());
    }
  }, [modelReservasByLocal]);

  useEffect(() => {
    const data = modelNroMesa?.data?.data;
    const error = modelNroMesa?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      hideNroMesa();
      dispatch(controller.addNroMesaDuck.actions.clear());
    }
    if (data) {
      setReservas([]);
      hideNroMesa();
      dispatch(
        controller.getReservasByLocalThunk(
          null,
          match.params.id,
          moment(fechaInicio).format("YYYY-MM-DD"),
          moment(fechaFin).format("YYYY-MM-DD"),
          activePage,
          pageSize,
          profesional,
          servicio,
          ambiente
        )
      );
      dispatch(controller.addNroMesaDuck.actions.clear());
    }
  }, [modelNroMesa]);

  useEffect(() => {
    const data = modelComentarioInterno?.data?.data;
    const error = modelComentarioInterno?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      hideComentario();
      dispatch(controller.addComentarioInternoDuck.actions.clear());
    }
    if (data) {
      setReservas([]);
      hideComentario();
      dispatch(
        controller.getReservasByLocalThunk(
          null,
          match.params.id,
          moment(fechaInicio).format("YYYY-MM-DD"),
          moment(fechaFin).format("YYYY-MM-DD"),
          activePage,
          pageSize,
          profesional,
          servicio,
          ambiente
        )
      );
      dispatch(controller.addComentarioInternoDuck.actions.clear());
    }
  }, [modelComentarioInterno]);



  useEffect(() => {
    dispatch(controllerLocal.localByIdThunk(match.params.id));
    dispatch(
      controller.getReservasByLocalThunk(
        null,
        match.params.id,
        moment(fechaInicio).format("YYYY-MM-DD"),
        moment(fechaFin).format("YYYY-MM-DD"),
        activePage,
        pageSize,
      )
    );
  }, []);

  function handlePage(page) {
    const profesionalOption = profesionalesOptions.filter(
      (elem) => elem.value === profesional
    );
    const servicioOption = serviciosOptions.filter(
      (elem) => elem.value === servicio
    );

    const subcategoriaOption = serviciosPadreOptions.filter(
      (elem) => elem.value === servicioPadre
    );
    setCurrentProfesional(
      profesionalOption && profesionalOption[0] ? profesionalOption[0] : null
    );
    setCurrentServicio(
      servicioOption && servicioOption[0] ? servicioOption[0] : null
    );

    setCurrentSubcategoria(
      subcategoriaOption && subcategoriaOption[0] ? subcategoriaOption[0] : null
    );
    setActivePage(page);
    setReservas([]);
    dispatch(
      controller.getReservasByLocalThunk(
        null,
        match.params.id,
        moment(fechaInicio).format("YYYY-MM-DD"),
        moment(fechaFin).format("YYYY-MM-DD"),
        activePage,
        pageSize,
        profesional,
        servicio,
        ambiente
      )
    );
  }

  function cancelarReserva(reserva) {
    var answer = window.confirm(
      "¿Esta seguro que desea cancelar esta reserva?"
    );
    if (answer) {
      dispatch(controller.cancelarReservaThunk(reserva));
    }
  }

  function showNroMesa(mostrar, nroMesa, id) {
    console.log({ mostrar, nroMesa, id });
    setShowModalNroMesa(mostrar);
    if (nroMesa) {
      setNroMesa(nroMesa);
    }

    setIdComentarioInterno(id);
  }

  function showComentario(mostrar, comentario, id) {
    console.log({ mostrar, comentario, id });
    setShow(mostrar);
    if (comentario) {
      setComentarioInterno(comentario);
    }

    setIdComentarioInterno(id);
  }

  function hideComentario() {
    setShow(false);
    setComentarioInterno("");
    setIdComentarioInterno(null);
  }

  function hideNroMesa() {
    setShowModalNroMesa(false);
    setNroMesa(0)
  };


  function guardarComentario() {
    const data = {
      id: idComentarioInterno,
      comentarioInterno
    }
    dispatch(controller.addCometnarioInternoThunk(data));
  }

  function guardarNroMesa() {
    const data = {
      id: idComentarioInterno,
      nroMesa,
    }
    dispatch(controller.addNroMesaThunk(data));
  }


  return (
    <Content
      title="Reservas"
      subTitle="Reservas"
      browserTitle="Reservas"
      show={false}
    >
      <Row>
        <Col md="12">
          <Modal
            show={showModalNroMesa}
            style={{ opacity: 1, paddingTop: 200 }}
            onHide={() => {
              hideNroMesa();
            }}
          >
            <Modal.Header closeButton={false}>
              <Modal.Title>Agregar nro</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Text
                labelPosition="above"
                label="Nro"
                inputType="number"
                value={nroMesa}
                onChange={(evt) => setNroMesa(evt.target.value)}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="primary"
                text="Guardar"
                onClick={() => guardarNroMesa()}
              />
            </Modal.Footer>
          </Modal>

          <Modal
            show={show}
            style={{ opacity: 1, paddingTop: 200 }}
            onHide={() => {
              hideComentario();
            }}
          >
            <Modal.Header closeButton={false}>
              <Modal.Title>Agregar comentario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Text
                labelPosition="above"
                label="Comentario"
                inputType="textarea"
                rows={5}
                value={comentarioInterno}
                onChange={(evt) => setComentarioInterno(evt.target.value)}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="primary"
                text="Guardar"
                onClick={() => guardarComentario()}
              />
            </Modal.Footer>

          </Modal>
          <Box title="Reservas con horarios obsoletos">
            <Col md="8">
              <Col md="3">
                <text>
                  <strong>Rango de fechas</strong>
                </text>
                <DateRangePicker
                  onCallback={(start, end, label) => {
                    setFechaInicio(start.format("YYYY-MM-DD"));
                    setFechaFin(end.format("YYYY-MM-DD"));
                  }}
                >
                  <input type="text" className="form-control" />
                </DateRangePicker>
              </Col>
              <Col md="3">
                <SelectInput
                  value={servicioPadre}
                  setValue={setServicioPadre}
                  label="Subcategoria"
                  options={serviciosPadreOptions}
                />
              </Col>
              <Col md="3">
                <SelectInput
                  value={servicio}
                  setValue={setServicio}
                  label="Servicio"
                  options={serviciosOptions}
                />
              </Col>
              {local && local.categoriaId !== "60f806a5e3e9af972fe85c7a" ? (
                <Col md="3">
                  <SelectInput
                    value={profesional}
                    setValue={setProfesional}
                    label="Profesional"
                    options={profesionalesOptions}
                  />
                </Col>
              ) : (
                <Col md="3">
                  <SelectInput
                    value={ambiente}
                    setValue={setAmbiente}
                    label="Ambiente"
                    options={ambienteOptions}
                  />
                </Col>
              )}

              <Col md="12">
                <div style={{ marginTop: 15 }}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(0)}
                  />
                </div>
              </Col>
            </Col>
            <Col md="12">
              <div style={{ marginTop: 15 }}>
                <div>
                  <span>Total: {totalResults}</span>
                </div>
              </div>
            </Col>
            {reservas && reservas.length > 0 ? (
              <Col md="12">
                <SimpleTable
                  hover={true}
                  data={reservas.map((row, index) => {
                    return {
                      usuario: row.detalles.nombre,
                      servicio: row.detalles.servicioNombre,
                      profesional: row.detalles.profesionalNombre,
                      estado: row.estado,
                      fecha: getFormattedDate(row.fecha),
                      hora: row.hora,
                      ambiente: row.detalles.ambienteNombre,
                      detalles: (
                        <Button
                          type="primary"
                          text="Detalles"
                          onClick={() => history.push(`/reserva/${row._id}`)}
                        />
                      ),
                      cancelar: (
                        <Button
                          type="danger"
                          text="Cancelar"
                          onClick={() => cancelarReserva(row)}
                        />
                      ),
                      comentario: (
                        <Button
                          type="warning"
                          text="Ver"
                          onClick={() =>
                            showComentario(
                              true,
                              row.comentarioInterno,
                              row._id
                            )
                          }
                        />
                      ),
                      nroMesa: (
                        <Button
                          type="primary"
                          text="Agregar Nro. Mesa"
                          onClick={() =>
                            showNroMesa(
                              true,
                              row.detalles.nroMesa,
                              row._id
                            )
                          }
                        />
                      ),

                    };
                  })}
                  columns={
                    local && local.categoriaId !== "60f806a5e3e9af972fe85c7a"
                      ? [
                        { title: "Usuario", data: "usuario" },
                        { title: "Servicio", data: "servicio" },
                        { title: "Profesional", data: "profesional" },
                        { title: "Estado", data: "estado" },
                        { title: "Fecha", data: "fecha" },
                        { title: "Hora", data: "hora" },
                        { title: "Detalles", data: "detalles" },
                        { title: "Cancelar", data: "cancelar" },
                        { title: "Comentario interno", data: "comentario" },
                      ]
                      : [
                        { title: "Usuario", data: "usuario" },
                        { title: "Servicio", data: "servicio" },
                        { title: "Estado", data: "estado" },
                        { title: "Fecha", data: "fecha" },
                        { title: "Ambiente", data: "ambiente" },
                        { title: "Detalles", data: "detalles" },
                        { title: "Cancelar", data: "cancelar" },
                        { title: "Comentario interno", data: "comentario" },
                        { title: "Agregar Nro. Mesa", data: "nroMesa" },
                      ]
                  }
                />
              </Col>
            ) : (
              <Col md="12">
                <h4>No se han encontrado reservas</h4>
              </Col>
            )}
            <Col md="12">
              <Pagination
                activePage={activePage}
                pageSize={pageSize}
                totalElements={totalResults}
                onChange={handlePage}
                labels={{
                  first: "Primera",
                  last: "Última",
                  previous: "Anterior",
                  next: "Siguiente",
                }}
              />
              <div>
                <span>Total: {totalResults}</span>
              </div>
            </Col>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default ReservasGeneralList;
